import { useState } from 'react'

const API = process.env.REACT_APP_API_URL

export default function PagoPlan({ plan, usuario, onCancelar }) {
  const [procesando, setProcesando] = useState(false)
  const [error,      setError]      = useState(null)

  async function handlePagar() {
    setProcesando(true)
    setError(null)
    try {
      const res = await fetch(API + '/pagos/suscripcion', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          usuario_email: usuario?.email || '',
          usuario_id:    usuario?.id    || '',
          plan_id:       plan.id,
          plan_nombre:   plan.nombre,
          precio:        plan.precio,
        }),
      })
      const data = await res.json()
      if (!data.ok) throw new Error(data.error || 'Error creating subscription')
      if (data.approve_url) {
        window.location.href = data.approve_url
      } else {
        throw new Error('No approval URL received from PayPal')
      }
    } catch (err) {
      setError(err.message)
      setProcesando(false)
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(145deg,#0a1628,#0f2347)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'system-ui, sans-serif',
      padding: 20,
    }}>
      <div style={{ maxWidth: 480, width: '100%' }}>

        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 20, fontWeight: 900, marginBottom: 4 }}>
            <span style={{ color: '#FFD700' }}>Esp</span>
            <span style={{ color: '#7BA7E8' }}>añ</span>
            <span style={{ color: '#FF8A8A' }}>olGo</span>
          </div>
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 13 }}>
            Secure payment powered by PayPal
          </p>
        </div>

        <div style={{
          background: `linear-gradient(135deg,${plan.color}dd,${plan.color})`,
          borderRadius: 16,
          padding: 24,
          marginBottom: 20,
          color: '#fff',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <span style={{ fontSize: 40 }}>{plan.emoji}</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 11, opacity: .8, marginBottom: 2, textTransform: 'uppercase', letterSpacing: 1 }}>
                Selected plan
              </div>
              <div style={{ fontSize: 20, fontWeight: 900 }}>{plan.nombre}</div>
              <div style={{ fontSize: 13, opacity: .85 }}>{plan.subprecio}</div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: 32, fontWeight: 900 }}>{plan.precio}</div>
              <div style={{ fontSize: 11, opacity: .7 }}>USD</div>
            </div>
          </div>
        </div>

        <div style={{ background: '#fff', borderRadius: 16, padding: 24, marginBottom: 16 }}>
          <h3 style={{ fontSize: 15, fontWeight: 800, color: '#1A1A2E', marginBottom: 16 }}>
            Order summary
          </h3>

          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10, fontSize: 14, color: '#374151' }}>
            <span>{plan.nombre}</span>
            <span style={{ fontWeight: 600 }}>{plan.precio} USD</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10, fontSize: 13, color: '#6B7280' }}>
            <span>PayPal processing fee</span>
            <span>Included</span>
          </div>
          <div style={{ height: 1, background: '#E2E6F0', margin: '12px 0' }} />
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 16, fontWeight: 800, color: '#1A1A2E' }}>
            <span>Total</span>
            <span>{plan.precio} USD</span>
          </div>

          <div style={{ marginTop: 20 }}>
            {error && (
              <div style={{
                background: '#FEF2F2',
                border: '1px solid #EF4444',
                borderRadius: 10,
                padding: '10px 14px',
                fontSize: 13,
                color: '#991B1B',
                marginBottom: 14,
              }}>
                ❌ {error}
              </div>
            )}

            <button
              onClick={handlePagar}
              disabled={procesando}
              style={{
                width: '100%',
                padding: '14px',
                background: procesando ? '#93C5FD' : '#0070BA',
                color: '#fff',
                border: 'none',
                borderRadius: 10,
                fontFamily: 'inherit',
                fontSize: 16,
                fontWeight: 800,
                cursor: procesando ? 'not-allowed' : 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 10,
              }}
            >
              {procesando ? (
                <>
                  <span style={{ fontSize: 18 }}>⏳</span>
                  Redirecting to PayPal...
                </>
              ) : (
                <>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                    <path d="M20.067 8.478c.492.315.844.825.983 1.39.272 1.115-.152 2.385-1.1 3.1-.507.386-1.13.59-1.77.59H16.5l-.5 3H13l2-12h4.5c.9 0 1.69.37 2.24.96l-.673 3.96zM7.5 6h4.5c1.1 0 2.1.4 2.85 1.1L13.5 12H10l-1 6H6l2-12z"/>
                  </svg>
                  Pay with PayPal
                </>
              )}
            </button>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 16, justifyContent: 'center' }}>
            <span style={{ fontSize: 16 }}>🔒</span>
            <span style={{ fontSize: 12, color: '#9CA3AF' }}>
              Secured by PayPal · SSL encrypted · Cancel anytime
            </span>
          </div>
        </div>

        <button
          onClick={onCancelar}
          style={{
            width: '100%',
            padding: '12px',
            background: 'none',
            border: '1px solid rgba(255,255,255,0.2)',
            borderRadius: 12,
            color: 'rgba(255,255,255,0.6)',
            fontFamily: 'inherit',
            fontSize: 14,
            cursor: 'pointer',
          }}
        >
          ← Back to plans
        </button>

      </div>
    </div>
  )
}
